import gql from "graphql-tag";

export const GET_CLUB_REVIEW = gql`
  query GetClubReview($club_profile_id: uuid) {
    club_reviews(
      where: { club_profile_id: { _eq: $club_profile_id } }
      order_by: { created_at: desc }
    ) {
      id
      title
      rating
      description
      user_view {
        id
        full_name
        profile_photo
        profile_photo_path
      }
    }
    club_reviews_aggregate(
      where: { club_profile_id: { _eq: $club_profile_id } }
    ) {
      aggregate {
        count
      }
    }
    average_rating: club_reviews_aggregate(
      where: { club_profile_id: { _eq: $club_profile_id } }
    ) {
      aggregate {
        avg {
          rating
        }
      }
    }
  }
`;
